import { handleGqlResponseBody } from "@/utils/apollo.util";
import { GET_ROOM_TARIFFS_PAGINATION_QUERY } from "@/graphql/queries/configuration/room-tariff/get-room-tariffs-pagination.query";

const roomTariff = {
  actions: {
    async getRoomTariffsQuery({ commit }, { skip, take, orderBy, query }) {
      return await handleGqlResponseBody(({ query: queryMethod }) => {
        return queryMethod({
          query: GET_ROOM_TARIFFS_PAGINATION_QUERY,
          variables: {
            skip,
            take,
            orderBy,
            query,
          },
          fetchPolicy: "no-cache",
        });
      });
    },
  },
};

export default roomTariff;
